var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98924 0.441406C8.15541 0.441406 9.89839 2.14596 9.89839 4.25035V5.33271C11.1142 5.7122 12 6.8128 12 8.12734V11.6122C12 13.2396 10.6508 14.5591 8.98745 14.5591H3.01327C1.34919 14.5591 0 13.2396 0 11.6122V8.12734C0 6.8128 0.886551 5.7122 2.10161 5.33271V4.25035C2.10879 2.14596 3.85176 0.441406 5.98924 0.441406ZM5.99641 8.47737C5.65212 8.47737 5.37239 8.75094 5.37239 9.08764V10.6449C5.37239 10.9886 5.65212 11.2622 5.99641 11.2622C6.34788 11.2622 6.62761 10.9886 6.62761 10.6449V9.08764C6.62761 8.75094 6.34788 8.47737 5.99641 8.47737ZM6.00359 1.66897C4.54752 1.66897 3.36402 2.81937 3.35684 4.23632V5.18049H8.64316V4.25035C8.64316 2.82638 7.45965 1.66897 6.00359 1.66897Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.978ffa3bfc8e5e4f222bdfdc8a5160f2.svg";
export { ForwardRef as ReactComponent };